<template>
    <div id="content_wrapper">
        <label id="commerce_law_rules_title">{{$t('rulesAtMyPage.commerceLawRuleTitle')}}</label>
        <div id="commerce_law_rules_wrapper">
            <div v-html="commerceLawRules"></div>
        </div>
    </div>
</template>

<script>
    import UserApi from "../../api/user/UserApi";

    export default {
        name: "CommerceLawRules",
        data() {
            return {
                commerceLawRules: "",
            }
        },

        created() {
            UserApi.getCommerceLawRules().then(result => {
                console.log(result)
                this.commerceLawRules = result.rules;
            })
        },

    }
</script>

<style scoped lang="scss">

    #content_wrapper {
        margin-left: 15%;
        margin-right: 15%;

        #commerce_law_rules_title {
            font-size: 110%;
            font-weight: bold;
        }

        #commerce_law_rules_wrapper {
            margin-top: 20px;
        }
    }

    @media only screen and (max-width: 450px){
        #content_wrapper {
            margin-left: 0;
            margin-right: 0;
        }
    }

</style>